import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/context/auth';
import { UserRoles } from '@/constants';

/**
 * Guards portal routes meant for admin personas only (Subscription today;
 * Clinic Details / Doctors carry the identical gap) — issue #307 follow-up,
 * direct feedback: portalAccountLinks already hides these from a plain
 * doctor's avatar menu, but hiding a tab only hides the tab. The route
 * itself stayed reachable by typing the URL directly, so a doctor (e.g.
 * test4.test4) could still land on /portal/subscription. A plain doctor
 * (role: doctor) always carries a doctorProfile by definition — the three
 * personas are plain doctor, admin+doctor, and admin-only — so /portal/link
 * is always a valid landing page to send a non-admin back to.
 */
export function PortalAdminGuard() {
  const { user } = useAuth();
  const isAdmin = user?.role === UserRoles.Admin;

  if (!isAdmin) {
    return <Navigate to="/portal/link" replace />;
  }

  return <Outlet />;
}
